function groupKingdoms(results) {
    const kingdomMap = {};
    
    results.forEach(({ kingdom, occurrence_count }) => {
        // Extract the main kingdom name by removing everything in parentheses
        const mainKingdom = kingdom.replace(/\s*\(.*?\)\s*/g, '');
        
        // Sum occurrence counts for each kingdom
        if (!kingdomMap[mainKingdom]) {
            kingdomMap[mainKingdom] = 0;
        }
        kingdomMap[mainKingdom] += occurrence_count;
    });
    
    // Convert the map back into an array of objects
    const res = Object.entries(kingdomMap).map(([kingdom, occurrence_count]) => ({
        kingdom,
        occurrence_count
    }));
    return res.sort((a, b) => b.occurrence_count - a.occurrence_count);
}


// Break the Plantae kingdom down into its parenthetical sub-groups, e.g.
// "Plantae (Angiosperm)" -> "Angiosperm". Enzymes carrying the bare "Plantae"
// label have no sub-group recorded; they are kept as "Unspecified" rather than
// dropped so the slices still add up to the Plantae total shown by
// groupKingdoms. Operates on the raw kingdomsCounts rows (one per full label).
function groupPlantaeSubgroups(results) {
    const subgroupMap = {};

    results.forEach(({ kingdom, occurrence_count }) => {
        if (!kingdom) return;
        // Anchored so only the Plantae kingdom is matched, never a label that
        // merely contains the word.
        const match = kingdom.trim().match(/^Plantae\s*(?:\((.*?)\))?$/);
        if (!match) return;
        const subgroup = match[1] ? match[1].trim() : 'Unspecified';
        subgroupMap[subgroup] = (subgroupMap[subgroup] || 0) + occurrence_count;
    });

    return Object.entries(subgroupMap)
        .map(([subgroup, occurrence_count]) => ({ subgroup, occurrence_count }))
        .sort((a, b) => b.occurrence_count - a.occurrence_count);
}


function groupTypesAndKingdoms(results){
    const customOrder = ['hemi', 'mono', 'sesq', 'di', 'sester', 'tri', 'sesquar', 'tetra', 'mero', 'pt', 'ids', "sqs", "psy"]
    const dictByType = {};
    const groups = []
    results.forEach(({type, kingdom, occurrence_count}) => {
        if (!dictByType[type]) {
            dictByType[type] = {};
        }
        const mainKingdom = kingdom.replace(/\s*\(.*?\)\s*/g, '');
        if (!groups.includes(mainKingdom)) {
            groups.push(mainKingdom);
        }
        if (!dictByType[type][mainKingdom]) {
            dictByType[type][mainKingdom] = 0;
        }
        dictByType[type][mainKingdom] += occurrence_count;
    })
    const res = [];
    Object.keys(dictByType).forEach((type) => {
        const obj = {type: type};
        const mergedObject = Object.assign({}, obj, dictByType[type]);
        res.push(mergedObject);
    });
    const sortedRes = res.sort((a, b) => {
        const indexA = customOrder.indexOf(a.type);
        const indexB = customOrder.indexOf(b.type);
        return indexA - indexB;
      });
    const completeData = sortedRes.map(entry => {
        let newEntry = { ...entry };
        groups.forEach(group => {
          if (!(group in newEntry)) {
            newEntry[group] = 0;
          }
        });
        return newEntry;
      });
    return [completeData, groups];
}

function groupSpeciesByKingdom(results) {
    const kingdomMap = {};

    results.forEach(({ kingdom, species }) => {
        if (!kingdom || !species) return;
        // Strip the parenthetical sub-kingdom suffix, matching groupKingdoms
        const mainKingdom = kingdom.replace(/\s*\(.*?\)\s*/g, '');
        if (!kingdomMap[mainKingdom]) {
            kingdomMap[mainKingdom] = new Set();
        }
        // Use a Set so a species appearing under several sub-kingdom labels is counted once
        kingdomMap[mainKingdom].add(species);
    });

    return Object.entries(kingdomMap)
        .map(([kingdom, speciesSet]) => ({ kingdom, species_count: speciesSet.size }))
        .sort((a, b) => b.species_count - a.species_count);
}

function calculateAminoAcidFrequency(sequences){
const frequency = {};
sequences.forEach(s => {
    if (s.aminoacid_sequence.includes("_")) {
        console.log(s)
    }
});

sequences.map(s => s.aminoacid_sequence).join("").split("").forEach(aa => {
    frequency[aa] = (frequency[aa] || 0) + 1;
});
delete frequency.X;
delete frequency["*"];
const orderedAA = Object.entries(frequency).sort((a, b) => b[1] - a[1]).map(([aa, freq]) => ({ aa, freq }))
return orderedAA;
}

// Turn the per-date enzyme insert/delete counts from the historic_note log
// (statsPageController.enzymeHistory) into a running total of live enzyme
// entries over time. The first event date is the initial database upload, so
// its cumulative value is used as the plot baseline.
function computeEnzymeHistory(history) {
    if (!history || history.length === 0) {
        return { series: [], baseline: 0 };
    }
    // SQL already orders by date, but sort defensively (string dates are ISO,
    // so lexical order == chronological order).
    const rows = [...history].sort((a, b) => (a.date < b.date ? -1 : a.date > b.date ? 1 : 0));
    let running = 0;
    const series = rows.map(({ date, inserts, deletes }) => {
        running += Number(inserts) - Number(deletes);
        // ts (ms since epoch) lets the chart use a real time axis, so the
        // x-distance is proportional to elapsed time (one month == one month).
        return { date, ts: new Date(date).getTime(), count: running };
    });
    return { series, baseline: series[0].count };
}

export { groupKingdoms, groupPlantaeSubgroups, groupTypesAndKingdoms, groupSpeciesByKingdom, calculateAminoAcidFrequency, computeEnzymeHistory };